import React, { FC, memo } from 'react';

import usePrefix from 'utils/usePrefix';
import FormDescription from 'components/ResqlExpert/FormDescription';
import {
  FormListStyled,
  FormSectionContentStyled,
  FormSectionStyled,
  TabBodyContentStyled,
} from 'components/ResqlExpert/SubmissionForm/styles';

interface SingleProps {
  titleKey: string;
  hintKey: string;
  value: string;
}

export const ReadOnlySingleField: FC<SingleProps> = memo(({ titleKey, hintKey, value }) => {
  const t = usePrefix('ResqlExpert');
  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t(titleKey)}>
          {hintKey ? (
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{ __html: t(hintKey) }} />
          ) : null}
        </FormDescription>
        <FormSectionContentStyled>
          <p>{value}</p>
        </FormSectionContentStyled>
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
});

interface ListProps {
  titleKey: string;
  hintKey: string;
  values: string[];
}

export const ReadOnlyListField: FC<ListProps> = memo(({ titleKey, hintKey, values }) => {
  const t = usePrefix('ResqlExpert');

  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t(titleKey)}>
          {hintKey ? (
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{ __html: t(hintKey) }} />
          ) : null}
        </FormDescription>
        <FormSectionContentStyled>
          <FormListStyled>
            {values.map((value, index) => (
              <li key={index}>{value}</li>
            ))}
          </FormListStyled>
        </FormSectionContentStyled>
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
});

interface DualProps {
  titleKey: string;
  hintKey: string;
  labelKeyA: string;
  valueA: string;
  labelKeyB: string;
  valueB: string;
}

export const ReadOnlyDualField: FC<DualProps> = memo(
  ({ titleKey, hintKey, labelKeyA, valueA, labelKeyB, valueB }) => {
    const t = usePrefix('ResqlExpert');

    return (
      <TabBodyContentStyled>
        <FormSectionStyled>
          <FormDescription title={t(titleKey)}>
            <p>{t(hintKey)}</p>
          </FormDescription>
          <FormSectionContentStyled>
            <div>
              <h4>{t(labelKeyA)}</h4>
              <p>{valueA}</p>
            </div>
            <div>
              <h4>{t(labelKeyB)}</h4>
              <p>{valueB}</p>
            </div>
          </FormSectionContentStyled>
        </FormSectionStyled>
      </TabBodyContentStyled>
    );
  },
);
